import { render, staticRenderFns } from "./Cotas.vue?vue&type=template&id=455c07bc"
import script from "./Cotas.vue?vue&type=script&lang=js"
export * from "./Cotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports